import { render, staticRenderFns } from "./RequisitionItemForm.vue?vue&type=template&id=24297a9d&scoped=true&"
import script from "./RequisitionItemForm.vue?vue&type=script&lang=ts&"
export * from "./RequisitionItemForm.vue?vue&type=script&lang=ts&"
import style0 from "./RequisitionItemForm.vue?vue&type=style&index=0&id=24297a9d&lang=scss&scoped=true&"
import style1 from "./RequisitionItemForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24297a9d",
  null
  
)

export default component.exports